import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const CATEGORIES = ['すべて', 'IT機器・ネットワーク', 'セキュリティ対策', 'IT・DX支援'];

const CASES = [
  {
    id: 1,
    category: 'セキュリティ対策',
    company: '有限会社湘南建設',
    industry: '建設業',
    challenge: '家庭用ルーターのまま運用、社内データが無防備な状態',
    result: 'UTM導入・ネットワーク再設計で不正アクセスをゼロに',
    period: '2023年〜現在',
    img: 'https://public.readdy.ai/ai/img_res/31283ccfcdd34c8f569ed024a4bea467.jpg',
    tags: ['UTM導入', 'ネットワーク再設計', 'セキュリティ強化'],
  },
  {
    id: 2,
    category: 'IT機器・ネットワーク',
    company: '医療法人さくらクリニック',
    industry: '医療・介護',
    challenge: '老朽化したPC・複合機の管理が煩雑で業務効率が低下',
    result: '機器を一括リプレイス、LAN再構築でネットワーク速度3倍',
    period: '2023年〜2024年',
    img: 'https://readdy.ai/api/search-image?query=clean%20medical%20clinic%20reception%20digital%20system%20tablet%2C%20modern%20healthcare%20office%2C%20professional%20doctor%20and%20nurse%2C%20clean%20white%20and%20sky%20blue%20interior%2C%20technology%20and%20care%2C%20bright%20warm%20atmosphere&width=600&height=400&seq=cs003&orientation=landscape',
    tags: ['PC一括導入', '複合機', 'LAN構築'],
  },
  {
    id: 3,
    category: 'IT・DX支援',
    company: '株式会社テックベンチャーズ',
    industry: 'IT・スタートアップ',
    challenge: '紙ベースの業務フローでDX化が進まない',
    result: '業務フロー整備とAI活用で月30時間の業務削減を実現',
    period: '2024年〜現在',
    img: 'https://readdy.ai/api/search-image?query=modern%20tech%20startup%20office%20space%20young%20Japanese%20professionals%20working%20collaborating%2C%20open%20workspace%2C%20casual%20corporate%20culture%2C%20plants%20and%20natural%20light%2C%20innovative%20atmosphere%2C%20sky%20blue%20accents&width=600&height=400&seq=cs004&orientation=landscape',
    tags: ['DX推進', 'AI活用', '業務効率化'],
  },
  {
    id: 4,
    category: 'セキュリティ対策',
    company: '株式会社湘南マニュファクチャリング',
    industry: '製造業',
    challenge: 'ウィルス感染被害を受け、セキュリティ体制の全面見直しが必要',
    result: 'セキュアブラウザ・ウィルス対策ソフト導入で再発防止を実現',
    period: '2023年',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manufacturing%20factory%20modern%20clean%20facility%2C%20industrial%20equipment%20machinery%2C%20professional%20workers%20safety%20gear%2C%20well%20organized%20production%20floor%2C%20quality%20and%20precision%2C%20warm%20soft%20industrial%20lighting&width=600&height=400&seq=cs005&orientation=landscape',
    tags: ['ウィルス対策', 'セキュアブラウザ', '情報漏洩防止'],
  },
  {
    id: 5,
    category: 'IT機器・ネットワーク',
    company: '株式会社サンライズフーズ',
    industry: '飲食業',
    challenge: '多店舗展開後、各店舗のWi-Fi・防犯カメラ環境がバラバラ',
    result: '全店舗のITインフラを統一、遠隔管理も可能に',
    period: '2022年〜2024年',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20restaurant%20interior%20clean%20minimalist%20design%2C%20warm%20lighting%2C%20wooden%20furniture%2C%20cozy%20atmosphere%2C%20professional%20food%20business%2C%20empty%20tables%20ready%20for%20service%2C%20Shonan%20coastal%20town&width=600&height=400&seq=cs001&orientation=landscape',
    tags: ['Wi-Fi構築', '防犯カメラ', '多拠点管理'],
  },
  {
    id: 6,
    category: 'IT・DX支援',
    company: '合同会社フジサワアグリ',
    industry: '農業・食品加工',
    challenge: 'ホームページが古くEC化も進んでいなかった',
    result: 'HP全面リニューアルとEC構築で売上1,500万円達成',
    period: '2022年〜2023年',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20organic%20farm%20agriculture%20field%20workers%20harvesting%2C%20fresh%20vegetables%20fruits%2C%20rural%20Kanagawa%20countryside%2C%20morning%20light%2C%20sustainable%20farming%2C%20peaceful%20and%20productive%20environment&width=600&height=400&seq=cs006&orientation=landscape',
    tags: ['HP作成', 'EC構築', 'DX支援'],
  },
];

const TESTIMONIALS = [
  {
    company: '有限会社湘南建設',
    role: '代表取締役',
    name: '田中 義明',
    text: '「ちゃんとしたセキュリティが必要なのはわかっているけど何から始めればいいか全然わからない」という状態から相談しました。丁寧にヒアリングしてもらい、うちの規模に合った現実的な対策を提案してもらえました。今では安心して業務に集中できています。',
    img: 'https://readdy.ai/api/search-image?query=professional%20Japanese%20male%20construction%20business%20owner%20portrait%2C%20friendly%20confident%20expression%2C%20casual%20business%20attire%2C%20clean%20neutral%20background%2C%2050s%2C%20professional%20headshot%20photography&width=200&height=200&seq=ts002&orientation=squarish',
  },
  {
    company: '株式会社サンライズフーズ',
    role: '代表取締役',
    name: '鈴木 浩一',
    text: 'PC・ネットワーク・複合機・防犯カメラまで、窓口が一つになったのが本当に助かっています。以前は複数の業者に連絡していたのが、湘南ビジネスサポートさんに任せてから手間が大幅に減りました。',
    img: 'https://readdy.ai/api/search-image?query=professional%20Japanese%20male%20business%20executive%20portrait%2C%20confident%20smile%2C%20suit%2C%20neutral%20background%2C%20headshot%2C%20trustworthy%20and%20approachable%2C%2050s%20age%2C%20high%20quality%20professional%20photo&width=200&height=200&seq=ts001&orientation=squarish',
  },
];

export default function CaseStudiesPage() {
  const [activeCategory, setActiveCategory] = useState('すべて');
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

  const filteredCases =
    activeCategory === 'すべて'
      ? CASES
      : CASES.filter((c) => c.category === activeCategory);

  useEffect(() => {
    const observers = sectionRefs.current.map((el) => {
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('animate-in');
            obs.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((obs) => obs?.disconnect());
  }, []);

  return (
    <div className="bg-[#F8FCFF] text-[#1A2E3A]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />

      {/* Hero */}
      <section className="relative h-80 flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=handshake%20business%20partnership%20agreement%20professional%20Japanese%20business%20people%20success%20collaboration%2C%20warm%20office%20lighting%2C%20trust%20and%20partnership%2C%20professional%20photography%2C%20soft%20blue%20and%20white%20background&width=1920&height=600&seq=cshero001&orientation=landscape"
            alt="事例紹介"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-[#163347]/70" />
        </div>
        <div className="relative z-10 w-full px-10 lg:px-20 pb-14">
          <p className="text-[#7EC8E8] text-xs tracking-[0.4em] mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>CASE STUDIES</p>
          <h1 className="text-white text-3xl lg:text-5xl font-light" style={{ fontFamily: "'Inter', 'Noto Sans JP', sans-serif" }}>
            事例紹介
          </h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="px-10 lg:px-20 py-4 flex items-center gap-2 text-xs text-[#5A7A8A] tracking-wider border-b border-[#C8E4F2]">
        <Link to="/" className="hover:text-[#2B8DB8] transition-colors cursor-pointer">ホーム</Link>
        <i className="ri-arrow-right-s-line" />
        <span>事例紹介</span>
      </div>

      {/* Intro */}
      <section className="py-16 px-10 lg:px-20 text-center">
        <div
          ref={(el) => { sectionRefs.current[0] = el; }}
          className="opacity-0 translate-y-8 transition-all duration-700 max-w-3xl mx-auto"
        >
          <p className="text-[#5A7A8A] text-sm leading-loose tracking-wider">
            これまでに支援してきた企業様の一部をご紹介します。セキュリティ対策・IT機器導入・DX推進など、業種・規模・課題はさまざまですが、私たちは常にお客様の実情に合った現実的な提案と伴走型の支援を行ってきました。
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="px-10 lg:px-20 pb-12">
        <div
          ref={(el) => { sectionRefs.current[1] = el; }}
          className="opacity-0 translate-y-8 transition-all duration-700 flex flex-wrap gap-3 justify-center"
        >
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 text-xs tracking-wider rounded-full border transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-[#2B8DB8] text-white border-[#2B8DB8]'
                  : 'bg-transparent text-[#5A7A8A] border-[#B8D8EC] hover:border-[#2B8DB8] hover:text-[#2B8DB8]'
              }`}
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              {cat}
            </button>
          ))}
        </div>
      </section>

      {/* Case Grid */}
      <section className="px-10 lg:px-20 pb-24">
        <div
          ref={(el) => { sectionRefs.current[2] = el; }}
          className="opacity-0 translate-y-8 transition-all duration-700 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {filteredCases.map((item) => (
            <div
              key={item.id}
              className="bg-white border border-[#C8E4F2] rounded-2xl overflow-hidden group hover:border-[#2B8DB8] transition-all duration-300 cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.company}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[#2B8DB8] text-xs tracking-wider bg-[#DFF0FB] px-3 py-1 rounded-full">
                    {item.category}
                  </span>
                  <span className="text-[#5A7A8A] text-xs">{item.industry}</span>
                </div>
                <h3 className="text-sm font-medium text-[#1A2E3A] mb-3 tracking-wider">{item.company}</h3>
                <div className="mb-4">
                  <div className="flex items-start gap-2 mb-2">
                    <span className="text-xs text-[#5A7A8A] tracking-wider flex-shrink-0 mt-0.5">課題</span>
                    <span className="text-xs text-[#1A2E3A] leading-relaxed">{item.challenge}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-xs text-[#2B8DB8] tracking-wider flex-shrink-0 mt-0.5 font-medium">成果</span>
                    <span className="text-xs text-[#2B8DB8] font-medium leading-relaxed">{item.result}</span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {item.tags.map((tag) => (
                    <span key={tag} className="text-[#5A7A8A] text-xs bg-[#EEF7FC] px-2.5 py-1 rounded-full">
                      #{tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-[#5A7A8A] text-xs">{item.period}</span>
                  <span className="text-[#2B8DB8] text-xs flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    詳細を見る <i className="ri-arrow-right-line text-xs" />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-[#163347] py-28 px-10 lg:px-20">
        <div
          ref={(el) => { sectionRefs.current[3] = el; }}
          className="opacity-0 translate-y-8 transition-all duration-700"
        >
          <div className="text-center mb-16">
            <p className="text-[#7EC8E8] text-xs tracking-[0.4em] mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>TESTIMONIALS</p>
            <h2 className="text-3xl font-light text-white" style={{ fontFamily: "'Inter', 'Noto Sans JP', sans-serif" }}>
              お客様の声
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {TESTIMONIALS.map((t) => (
              <div key={t.name} className="border border-white/10 rounded-2xl p-8">
                <i className="ri-double-quotes-l text-3xl text-[#2B8DB8] mb-5 block" />
                <p className="text-white/80 text-sm leading-loose tracking-wider mb-8">{t.text}</p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.img} alt={t.name} className="w-12 h-12 object-cover object-top rounded-full" />
                  </div>
                  <div>
                    <p className="text-white text-sm font-medium tracking-wider">{t.name}様</p>
                    <p className="text-white/50 text-xs tracking-wider">{t.company} {t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-[#EEF7FC] py-20 px-10 lg:px-20">
        <div
          ref={(el) => { sectionRefs.current[4] = el; }}
          className="opacity-0 translate-y-8 transition-all duration-700 grid grid-cols-2 lg:grid-cols-4 gap-10 max-w-4xl mx-auto text-center"
        >
          {[
            { num: '300+', label: '支援企業数' },
            { num: '98%', label: '継続率' },
            { num: '3', label: '事業カテゴリー' },
            { num: '1社', label: 'ワンストップ対応' },
          ].map((s) => (
            <div key={s.label}>
              <p className="text-[#2B8DB8] text-5xl font-light mb-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                {s.num}
              </p>
              <p className="text-[#5A7A8A] text-xs tracking-widest">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-10 text-center">
        <div
          ref={(el) => { sectionRefs.current[5] = el; }}
          className="opacity-0 translate-y-8 transition-all duration-700"
        >
          <p className="text-[#2B8DB8] text-xs tracking-[0.4em] mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>CONTACT</p>
          <h2 className="text-3xl font-light text-[#1A2E3A] mb-5" style={{ fontFamily: "'Inter', 'Noto Sans JP', sans-serif" }}>
            あなたの会社のIT課題も、一緒に解決しましょう
          </h2>
          <p className="text-[#5A7A8A] text-sm tracking-wider mb-10">
            まずは無料相談で現状と課題をお聞かせください。
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#2B8DB8] text-white text-xs tracking-widest rounded-full hover:bg-[#1E6E94] transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            無料相談を申し込む
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>

      <Footer />

      <style>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </div>
  );
}
